(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-facility-lab', {
            parent: 'entity',
            url: '/covid-facility-lab?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'CovidFacilityLabs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-facility-lab/covid-facility-labs.html',
                    controller: 'CovidFacilityLabController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access);
                }]
            }
        })
        .state('covid-facility-lab.new', {
            parent: 'covid-facility-lab',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-dialog.html',
                        controller: 'CovidFacilityLabDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    facility: CoreService.getCurrentFacility(),
                                    facilityLab: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('covid-facility-lab');
                    });
                }
            }]
        })
        .state('covid-facility-lab.edit', {
            parent: 'covid-facility-lab',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-dialog.html',
                        controller: 'CovidFacilityLabDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['CovidFacilityLab', function (CovidFacilityLab) {
                                return CovidFacilityLab.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('covid-facility-lab.delete', {
            parent: 'covid-facility-lab',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-delete-dialog.html',
                        controller: 'CovidFacilityLabDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['CovidFacilityLab', function (CovidFacilityLab) {
                                return CovidFacilityLab.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();
